export const onTempPasswordUpdateSuccess = (data, get) => {
  const { userId, temporaryPassword = null } = data;
  get().setTemporaryPassword(userId, temporaryPassword);
};
